/**
 * JDS Search Drawer
 * 1. Forces the search modal to open as a right-side drawer via inline styles
 *    (inline styles beat the browser's top-layer UA stylesheet).
 * 2. Manages "View X results" button text.
 */
(function initSearchDrawer() {

  /* ── Drawer positioning ───────────────────────────────────────── */

  const DRAWER_STYLES = {
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    left: 'auto',
    margin: '0',
    width: 'min(480px, 100dvw)',
    maxWidth: '100dvw',
    height: '100dvh',
    maxHeight: '100dvh',
    borderRadius: '0',
    overflow: 'hidden',
    boxShadow: '-4px 0 32px rgba(0, 0, 0, 0.12)',
    border: 'none',
    borderLeft: '1px solid rgba(0,0,0,0.1)',
    padding: '0',
  };

  function applyDrawerStyles(dialog) {
    Object.assign(dialog.style, DRAWER_STYLES);
  }

  function removeDrawerStyles(dialog) {
    Object.keys(DRAWER_STYLES).forEach(function (key) {
      dialog.style[key] = '';
    });
  }

  /* ── Count fetch ──────────────────────────────────────────────── */

  let countController = null;

  function fetchAndSetCount(component, term) {
    const btn = component.querySelector('.predictive-search__search-button');
    if (!btn) return;

    if (countController) countController.abort();
    countController = new AbortController();

    fetch(
      '/search?q=' + encodeURIComponent(term) + '&type=product&view=count',
      { signal: countController.signal }
    )
      .then(function (r) { return r.text(); })
      .then(function (text) {
        const count = parseInt(text.trim(), 10);
        const b = component.querySelector('.predictive-search__search-button');
        if (!b) return;
        if (!isNaN(count)) {
          b.textContent = 'View ' + count.toLocaleString() + ' results for "' + term + '"';
        } else {
          b.textContent = 'View all results for "' + term + '"';
        }
      })
      .catch(function () {});
  }

  /* ── Watch search input for typing ───────────────────────────── */

  function watchInput(component) {
    const input = component.querySelector('input[name="q"]');
    if (!input) return;

    input.addEventListener('input', function () {
      const term = input.value.trim();
      if (term.length > 0) {
        // Small delay so results are already morphed in by the time we fetch count
        setTimeout(function () {
          fetchAndSetCount(component, term);
        }, 350);
      } else {
        const btn = component.querySelector('.predictive-search__search-button');
        if (btn) btn.textContent = 'View all results';
      }
    });
  }

  /* ── Ensure footer is always visible ─────────────────────────── */

  function ensureFooterVisible(component) {
    var footer = component.querySelector('.predictive-search-form__footer');
    if (footer) {
      footer.style.setProperty('display', 'block', 'important');
      footer.style.flexShrink = '0';
    }
  }

  /* ── Init ─────────────────────────────────────────────────────── */

  function init() {
    const searchModalComponent = document.getElementById('search-modal');
    if (!searchModalComponent) return;

    const dialog    = searchModalComponent.querySelector('dialog');
    const component = searchModalComponent.querySelector('predictive-search-component');
    if (!dialog || !component) return;

    searchModalComponent.addEventListener('dialog:open', function () {
      applyDrawerStyles(dialog);
      ensureFooterVisible(component);
      watchInput(component);
    });

    searchModalComponent.addEventListener('dialog:close', function () {
      removeDrawerStyles(dialog);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
